import Component from '@glimmer/component';
import pageTitle from 'ember-page-title/helpers/page-title';
import { Input } from '@ember/component';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type SessionService from 'bcl/services/session';

export default class LoginRoute extends Component {
  @service declare router: RouterService;
  @service declare session: SessionService;
  @tracked email = '';
  @tracked password = '';
  @tracked error = '';
  @action
  async login(event: PointerEvent) {
    event.preventDefault();
    this.error = '';
    try {
      await this.session.authenticate(this.email, this.password);
      this.router.transitionTo('auth');
    } catch (e) {
      console.log(e);
      this.error = e.message as string;
    }
  }
  <template>
    {{pageTitle "Login"}}

    <div class="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div class="sm:mx-auto sm:w-full sm:max-w-sm">
        <img
          class="mx-auto h-10 w-auto"
          src="/img/piceatech-logo.png"
          alt="Your Company"
        />
        <h2
          class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900"
        >Logge Dich in deinen Account ein:</h2>
      </div>

      <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form class="space-y-6">
          <div>
            <label
              for="email"
              class="block text-sm font-medium leading-6 text-gray-900"
            >Email Adresse</label>
            <div class="mt-2">
              <Input
                id="email"
                name="email"
                @type="email"
                @value={{this.email}}
                autocomplete="email"
                required
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <div class="flex items-center justify-between">
              <label
                for="password"
                class="block text-sm font-medium leading-6 text-gray-900"
              >Passwort</label>
              <div class="text-sm">
                <a
                  href="#"
                  class="font-semibold text-indigo-600 hover:text-indigo-500"
                >Passwort vergessen?</a>
              </div>
            </div>
            <div class="mt-2">
              <Input
                id="password"
                name="password"
                @type="password"
                @value={{this.password}}
                autocomplete="current-password"
                required
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <button
              {{on "click" this.login}}
              type="button"
              class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >Einloggen</button>
          </div>
          {{#if this.error}}
            <div>
              Fehler:
              {{this.error}}
            </div>
          {{/if}}
        </form>

        <p class="mt-10 text-center text-sm text-gray-500">
          Noch kein Account?
          <a
            href="#"
            class="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
          >Starte eine kostenlose 30 Tage Testphase</a>
        </p>
      </div>
    </div>
  </template>
}
